import { ReactElement } from "react";

export const QuestionIcon = ({ ...props }): ReactElement => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.7505 2.47059C18.2645 2.47059 21.9564 6.486 21.9564 12C21.9564 17.514 18.2645 21.1765 12.7505 21.1765C7.23649 21.1765 3.2505 17.514 3.2505 12C3.2505 6.486 7.23649 2.47059 12.7505 2.47059ZM12.7505 0C6.12349 0 0.750488 5.373 0.750488 12C0.750488 18.627 6.12349 24 12.7505 24C19.3775 24 24.7505 18.627 24.7505 12C24.7505 5.373 19.3775 0 12.7505 0ZM14.0005 17C14.0005 17.69 13.4415 18.25 12.7505 18.25C12.0615 18.25 11.5005 17.69 11.5005 17C11.5005 16.31 12.0615 15.75 12.7505 15.75C13.4415 15.75 14.0005 16.31 14.0005 17ZM15.3935 7.002C14.7855 6.386 13.8785 6.047 12.8425 6.047C10.9809 6.047 9.68087 7.17722 9.34076 9.00181C9.23956 9.54474 9.7057 9.997 10.258 9.997C10.8103 9.997 11.2285 9.53225 11.4189 9.01383C11.6922 8.26977 12.2794 7.984 12.8015 7.984C13.4355 7.984 14.1085 8.405 14.1655 9.21C14.2275 10.057 13.7755 10.487 13.2035 11.031C12.1506 12.0325 11.8683 12.6486 11.7954 13.5088C11.7491 14.0546 12.2144 14.499 12.7621 14.499C13.3191 14.499 13.7137 14.022 13.9093 13.5005C14.0342 13.1676 14.2705 12.796 14.7115 12.321C15.3885 11.591 16.2305 10.683 16.2475 9.299C16.2585 8.375 15.9635 7.58 15.3935 7.002Z"
      />
    </svg>
  );
};
